module.exports = __webpack_public_path__ + "img/74ba21a.png";